import { Box } from '@mui/material';
import React, { FormEvent, PropsWithChildren } from 'react';
import { FormProvider, SubmitHandler, UseFormReturn, FieldValues } from 'react-hook-form';

type FormProps<FormData extends FieldValues> = {
  form: UseFormReturn<FormData>;
  onSubmit?: SubmitHandler<FormData>;
};

const Form = <FormData extends FieldValues>({ children, form, onSubmit }: PropsWithChildren<FormProps<FormData>>) => {
  const { handleSubmit } = form;

  const submit = (e: FormEvent<HTMLFormElement>) => {
    onSubmit && handleSubmit(onSubmit)(e);
  };

  return (
    <FormProvider {...form}>
      <Box data-testid="form" component="form" noValidate onSubmit={submit} width="100%">
        {children}
      </Box>
    </FormProvider>
  );
};

export default Form;
